import swal from "sweetalert2";

import "@/assets/estilo.css";

export default {
  extrairMensagemErro(detalhe) {
    if (!detalhe) {
      return undefined;
    }
    let parent = detalhe.response ? detalhe.response.data : detalhe;
    return parent.exceptionMessage || parent.message || parent;
  },
  async exibirErro(titulo = "Ocorreu um erro", detalhe = null) {
    await swal.fire({
      title: titulo,
      text: this.extrairMensagemErro(detalhe),
      type: "error",
    });
  },
  async exibirSucesso(titulo = "Sucesso!", detalhe = null) {
    await swal.fire({
      title: titulo,
      text: detalhe,
      type: "success",
    });
  },
  async pedirConfirmacao(pergunta, detalhe = null) {
    return (
      (
        await swal.fire({
          title: pergunta,
          text: detalhe,
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Sim",
          confirmButtonColor: "#563d7c",
          cancelButtonText: "Não",
        })
      ).value || false
    );
  },
  async exibirInformacao(titulo, detalhe = null, tipo = null) {
    return await swal.fire({
      title: titulo,
      text: detalhe,
      type: tipo || "info",
    });
  },
  async exibirMensagemComImagem(url, altura, largura, titulo, detalhe = null) {
    return await swal.fire({
      imageUrl: url,
      imageHeight: altura,
      imageWidth: largura,
      title: titulo,
      text: detalhe,
    });
  },
  async exibirErroHtml(titulo = "Ocorreu um erro", html = null) {
    await swal.fire({
      title: titulo,
      html: html,
      type: "error",
      width: "75%",
    });
  },
  async exibirSucessoHtml(titulo = "Sucesso!", html = null) {
    await swal.fire({
      title: titulo,
      html: html,
      type: "success",
    });
  },
  async exibirMensagemCompatilhamento(titulo = "Sucesso!", html = null) {
    return (
      (
        await swal.fire({
          title: titulo,
          type: "success",
          showConfirmButton: true,
          confirmButtonText: html,
          confirmButtonColor: "#008000",
          showCloseButton: true,
          customClass: {
            confirmButton: "whatsappButton",
          },
        })
      ).value || false
    );
  },
  async pedirConfirmacaoAtencao(pergunta, detalhe = null) {
    return (
      (
        await swal.fire({
          title: pergunta,
          text: detalhe,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Sim",
          confirmButtonColor: "#563d7c",
          cancelButtonText: "Não",
        })
      ).value || false
    );
  },
};
